import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HttpHeaderInterceptor } from '@app/interceptors/http.header.interceptor';
import { LoadingInterceptor } from '@app/interceptors/http.loading.interceptor';
import { HttpPayloadInterceptor } from '@app/interceptors/http.payload.interceptor';
import { HttpResponseInterceptor } from '@app/interceptors/http.response.interceptor';
import { OtpService } from './authenticators/otp.service';
import { CertificateService } from './certificates/certificate.service';
import { CorrelationIdService } from './correlation-id.service';
import { OAuth2Service } from './oauth2.service';
import { SessionService } from './session/session.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpHeaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpPayloadInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpResponseInterceptor,
      multi: true,
    },

    OtpService,
    CertificateService,
    SessionService,
    CorrelationIdService,
    OAuth2Service,
  ],
  declarations: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CoreModule {}
